<template>
	<div class="MobileModalFooter">
		<button
			v-if="clearText && clear"
			class="ClearButton"
			:aria-label="clearText"
			@click="clear && clear()"
		>
			{{ clearText }}
		</button>
		<button
			:class="['ActionButton', actionType]"
			@click="action"
			:aria-label="actionText"
		>
			{{ actionText }}
		</button>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useMobileModal } from '@composables/useMobileModal';
const { modalState } = useMobileModal();

const actionText = computed(() => {
	return modalState.value.props.footer?.actionText || 'Show Results';
});

const action = computed<(() => void) | undefined>(() => {
	return modalState.value.props.footer?.action;
});

const actionType = computed<'primary' | 'secondary'>(() => {
	return modalState.value.props.footer?.actionType || 'primary';
});

const clearText = computed<string | undefined>(() => {
	return modalState.value.props.footer?.clearText;
});

const clear = computed<(() => void) | undefined>(() => {
	return modalState.value.props.footer?.clear;
});

</script>

<style scoped lang="scss">
	.MobileModalFooter {
		position: absolute;
		bottom: 0;
		width: calc(100dvw - 2rem);
		display: flex;
		gap: 1rem;
		justify-content: flex-end;
		border-top: 1px solid $Grey-300;
		background: $White;
		box-shadow: $TopBoxShadow;

		@include PaddingAreas(1);

		.ClearButton {
			color: $Blue-700;
			cursor: pointer;

			@include TextStyle(BodySmallRegular);
			@include MarginAreas(0);
		}

		.ActionButton {
			border-radius: 0.25rem;
			min-width: 12.5rem;
			height: 3rem;
			cursor: pointer;

			@include TextStyle(UiMediumSemibold);
			@include MarginAreas(0, 0);

			&.primary {
				background: $Orange-500;
				color: $White;
			}

			&.secondary {
				background: $White;
				color: $Grey-900;
				border: 2px solid $Grey-900;
			}

		}

		.ActionButton, .ClearButton {
			background: none;
			border: none;
			padding: 0;
			user-select: none;
		}
	}
</style>